import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { PageCabinetComponent } from './page-cabinet.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { HeaderMenuService } from './header-menu/header-menu.service';
import { PageCabinetService } from './page-cabinet.service';
import { ChangeLogsWidgetComponent } from './change-logs-widget/change-logs-widget.component';
import { OperatorStatusesComponent } from './operator-statuses/operator-statuses.component';
import { WhatsappNotifierService } from './whatsapp-notifier/whatsapp-notifier.service';
import { PortalModule } from '@angular/cdk/portal';
import { WhatsappNotifierComponent } from './whatsapp-notifier/whatsapp-notifier.component';
import { provideVimCoreBaseConfig } from '@skyeng/libs/vimbox-core/base';
import { OverlayModule } from '@angular/cdk/overlay';
import { environment } from '@environment';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { MailNotifierModule } from './mail-notifier';
import { VimbotNotifierModule } from './vimbot-notifier';
import { HeaderLangSelectModule } from './header-lang-select/header-lang-select.module';
import { QuicklinkModule } from 'ngx-quicklink';
import { SharedModule } from '@shared/shared';
import { AlertModule } from '@shared/shared/components/alert';
import { SubmenuComponent } from './header-menu/submenu/submenu.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    MailNotifierModule,
    VimbotNotifierModule,
    PortalModule,
    OverlayModule,
    HeaderLangSelectModule,
    TranslocoModule,
    QuicklinkModule,
    AlertModule,
  ],
  exports: [PageCabinetComponent, SpinnerComponent, ProgressBarComponent],
  declarations: [
    HeaderComponent,
    HeaderMenuComponent,
    PageCabinetComponent,
    ProgressBarComponent,
    SpinnerComponent,
    ChangeLogsWidgetComponent,
    OperatorStatusesComponent,
    WhatsappNotifierComponent,
    SubmenuComponent,
  ],
  providers: [
    HeaderMenuService,
    PageCabinetService,
    WhatsappNotifierService,
    provideVimCoreBaseConfig({
      rootDomain: environment.baseHost,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PageCabinetModule {
  constructor(private transloco: TranslocoService) {
    registerTranslationsManually('mainLayout', this.transloco, import.meta.webpackContext!('./translation'));
  }
}
